// extracted by mini-css-extract-plugin
module.exports = {"message":"app-auth-message_message_2eaEm"};